import getThreadContentItemByThreadId from '@/lib/threads/getThreadContentItemByThreadId.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import normalizeThreadTitle from '@/lib/threads/normalizeThreadTitle.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';
import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';

const applyThreadTitleMutation = ({ state, threadId, title, updatedAt }) => {
  if (!threadId) {
    return state;
  }

  const existingMeta = getThreadsById(state.threads)?.[threadId];
  const existingContent = getThreadContentItemByThreadId(state.threadContent, threadId);

  if (!existingMeta || !existingContent) {
    if (!existingMeta) {
      return state;
    }
  }

  const nextTitle = normalizeThreadTitle(title);

  if (!nextTitle) {
    return state;
  }

  const nextUpdatedAt = updatedAt || existingMeta.updatedAt || new Date().toISOString();
  const nextThreadMeta = {
    ...existingMeta,
    title: nextTitle,
    updatedAt: nextUpdatedAt
  };

  return {
    ...state,
    threads: upsertSortedThread(state.threads, nextThreadMeta),
    ...(existingContent
      ? {
          threadContent: upsertThreadContentItem(state.threadContent, {
            ...existingContent,
            threadId,
            header: {
              ...(existingContent?.header || {}),
              title: nextTitle
            }
          })
        }
      : {})
  };
};

export default applyThreadTitleMutation;
